import React from 'react';
import PropTypes from 'prop-types';
import League from './League';
var Teams = function Teams(_ref) {
  var parentNavItem = _ref.parentNavItem,
    navPosition = _ref.navPosition,
    teamData = _ref.teamData;
  //eslint-disable-next-line no-unused-vars
  var teamLeagues = teamData && teamData.leagues || [];
  var teamLeaguesCopy = teamLeagues.slice();

  // Add Teams Home link to Subnav
  if (navPosition === 'side') {
    teamLeaguesCopy.push({
      name: 'Teams Home link for subnav dropdown',
      divisions: [{
        teams: [{
          name: "".concat(parentNavItem.text),
          shortName: "".concat(parentNavItem.text),
          url: parentNavItem.url,
          isHomeLink: true
        }]
      }]
    });
  }
  var renderTeams = teamLeaguesCopy.map(function (league) {
    return /*#__PURE__*/React.createElement(League, {
      key: league.name,
      league: league,
      navPosition: navPosition
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "header__subnav header__subnav--teams",
    "data-parent-nav-id": "nav-side-item-teams"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leagues header__subnav--teams__leagues",
    "aria-label": "Leagues Flyout"
  }, renderTeams));
};
export default Teams;
Teams.propTypes = {
  parentNavItem: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string
  }),
  navPosition: PropTypes.string,
  teamData: PropTypes.shape({
    leagues: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      divisions: PropTypes.instanceOf(Array)
    }))
  })
};